"use strict";
exports.__esModule = true;
exports.MerchantChannelBuilder = exports.MerchantChannelType = exports.MerchantChannelConfiguration = void 0;
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var MerchantChannelConfiguration = /** @class */ (function () {
    function MerchantChannelConfiguration() {
    }
    MerchantChannelConfiguration.getEditableSides = function (merchantChannelConfiguration) {
        return core_designer_domain_1.DesignerApplicationConfiguration.getEditableSides(merchantChannelConfiguration.sideConfig);
    };
    return MerchantChannelConfiguration;
}());
exports.MerchantChannelConfiguration = MerchantChannelConfiguration;
var MerchantChannelType;
(function (MerchantChannelType) {
    MerchantChannelType["MAGENTO"] = "MAGENTO";
    MerchantChannelType["SHOPIFY"] = "SHOPIFY";
    MerchantChannelType["WOO_COMMERCE"] = "WOO_COMMERCE";
    MerchantChannelType["JEWELUTIONS"] = "JEWELUTIONS";
})(MerchantChannelType = exports.MerchantChannelType || (exports.MerchantChannelType = {}));
var MerchantChannelBuilder = /** @class */ (function () {
    function MerchantChannelBuilder(merchantChannel) {
        this.merchantChannel = merchantChannel;
    }
    MerchantChannelBuilder.initialiseWithMerchantChannel = function (merchantChannel) {
        return new MerchantChannelBuilder(merchantChannel);
    };
    MerchantChannelBuilder.initialise = function (partyId, name, domain, channelType, configuration) {
        return new MerchantChannelBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            active: false,
            partyId: partyId,
            name: name,
            domain: domain,
            channelType: channelType,
            configuration: configuration,
            defaultChannelCatalog: undefined,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    MerchantChannelBuilder.prototype.build = function () {
        return this.merchantChannel;
    };
    MerchantChannelBuilder.prototype.buildUpdate = function () {
        return {
            active: this.merchantChannel.active,
            partyId: this.merchantChannel.partyId,
            name: this.merchantChannel.name,
            domain: this.merchantChannel.domain,
            channelType: this.merchantChannel.channelType,
            configuration: this.merchantChannel.configuration,
            defaultChannelCatalog: this.merchantChannel.defaultChannelCatalog
        };
    };
    MerchantChannelBuilder.prototype.getId = function () {
        return this.merchantChannel.id;
    };
    MerchantChannelBuilder.prototype.withId = function (id) {
        this.merchantChannel.id = id;
        return this;
    };
    MerchantChannelBuilder.prototype.setActive = function () {
        this.merchantChannel.active = true;
        return this;
    };
    MerchantChannelBuilder.prototype.setInactive = function () {
        this.merchantChannel.active = false;
        return this;
    };
    MerchantChannelBuilder.prototype.withDefaultChannelCatalog = function (defaultChannelCatalog) {
        this.merchantChannel.defaultChannelCatalog = defaultChannelCatalog;
        return this;
    };
    MerchantChannelBuilder.prototype.withConfiguration = function (configuration) {
        this.merchantChannel.configuration = configuration;
        return this;
    };
    return MerchantChannelBuilder;
}());
exports.MerchantChannelBuilder = MerchantChannelBuilder;
